import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {IBorderRadius} from '../../../../incase-domain/common/borderRadius';
import SymmetricInput from '../../form/slideSettings/SymmetricInput';

interface BorderRadiusChangeProps {
    borderRadius?: IBorderRadius;
    highlightedElementChangeHandler: (value: unknown) => void;
}

function BorderRadiusChange(props: BorderRadiusChangeProps): ReactElement {
    const {borderRadius, highlightedElementChangeHandler} = props;
    const {t} = useTranslation();

    return (
        <SymmetricInput
            label={t('designSidepanel.borderRadius')}
            inputs={['upperLeft', 'upperRight', 'lowerRight', 'lowerLeft']}
            icons={[
                'radix-icons:corner-top-left',
                'radix-icons:corner-top-right',
                'radix-icons:corner-bottom-right',
                'radix-icons:corner-bottom-left',
            ]}
            value={borderRadius}
            onChange={(value: IBorderRadius) => highlightedElementChangeHandler(value)}
        />
    );
}

export default BorderRadiusChange;
